import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SetGameScoreboardStats } from '../../../../scoreboards/models/scoreboard-stats';

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    templateUrl: './my-bets-set-scoreboard-stats.html',
    selector: 'ms-my-bets-set-scoreboard-stats',
})
export class MyBetsSetScoreboardStatsComponent {
    vm = input.required<SetGameScoreboardStats>();

    getClass(): string {
        if (this.vm().sets.list.length >= 7) {
            return 'mybets-scoreboard_stats__sets_7';
        }
        if (this.vm().sets.list.length >= 5) {
            return 'mybets-scoreboard_stats__sets_5';
        }

        return '';
    }
}
